import { PublishTradingOfferModalContextType } from '../types/PublishTradingOfferModalContextType';

export const publishTradingOfferModalInitValue: PublishTradingOfferModalContextType =
  {
    data: {
      modalActionType: '',
      tradingOffer: null,
      publishedOffer: null,
      validityDays: 0,
      isTermsAndConditionsAccepted: false,
      isPurchaseContractAccepted: false,
      isHideSellerName: false,
      isLoading: true,
      currentStep: 1,
      publisherPartner: null,
      publisherDocuments: [],
      emailSubsidiary: '',
    },
    actions: {
      handleCloseModal: () => {},
      handleNextStep: () => {},
      handlePrevStep: () => {},
      handleChangeTermsAndConditionsAcceptance: () => {},
      handleChangePurchaseContractAcceptance: () => {},
      handleChangeHideSellerName: () => {},
      handleAddPublisherDocument: () => {},
      handleRemovePublisherDocument: () => {},
      handleUpdatePublisherPartnerField: () => {},
      handleUpdatePublisherPartnerAddressField: () => {},
      handleUpdateEmailSubsidiary: () => {},
      handlePublishTradingOffer: async () => {},
    },
  };
